// hooks
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';

const useDealsPlatformRedirect = (pageName: string) => {
  const pagesOnV1 = useRemoteConfig('dealsPlatformV1Pages') as string[];
  return Array.isArray(pagesOnV1) && pagesOnV1.includes(pageName) === false;
};

export default useDealsPlatformRedirect;
